import {
  AddCircle,
  ChangeCircle,
  Description,
  HourglassBottom,
  Paid,
  Print,
  SwapCallsOutlined,
  SwapHorizontalCircle,
  Visibility,
} from "@mui/icons-material";
import { Box, Grid, TextField, Typography } from "@mui/material";
import useApi from "_api/index";
import { Table } from "antd";
import Actions from "components/Car/Actions";
import TableData from "components/Car/Table";
import ChipCustomize from "components/Chip";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import ModalDetailCar from "components/Modal/Car/ModalDetailCar";
import ModalInterest from "components/Modal/Car/ModalInterest";
import ModalPawnCar from "components/Modal/Car/ModalPawnCar";
import CustomPagination from "components/TableExplanded/Pagination";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  formatCurrency2Digit,
  formatDateMonthYear,
  formatDateTime,
} from "utils/helpers/format";

const PawnCars = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [pawnCars, setPawnCars] = React.useState([]);
  const [pagination, setPagination] = React.useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 1,
  });
  const [filter, setFilter] = React.useState({
    search: "",
    searchName: "",
    searchIdcard: "",
    searchDate: "",
    searchPrice: "",
  });
  const [isOpenModal, setIsOpenModal] = React.useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = React.useState(false);
  const [isInterestModalOpen, setIsInterestModalOpen] = React.useState(false);
  const [selectedCar, setSelectedCar] = React.useState(null);
  const [typeActions, setTypeActions] = React.useState("interest");

  const fetchData = async (isClear = false) => {
    setLoading(true);
    try {
      const response = await useApi.pawn_car.getListPawnCar({
        page: isClear ? 1 : pagination.page,
        limit: pagination.limit,
        ...(isClear ? {} : filter),
      });
      if (response.success) {
        const { data, meta } = response;
        const formattedData = data.map((item) => ({
          ...item,
          ...item.car,
          ...item.car.customer,
          id: item.id,
        }));
        setPawnCars(formattedData ?? []);
        setPagination({
          page: meta.page || 1,
          limit: meta.limit || 10,
          total: meta.total || 0,
          totalPages: meta.totalPages || 1,
        });
      }
    } catch (error) {
      console.error("Error fetching pawn cars:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination.page, pagination.limit]);

  const handleUpdateStsatusForFeiture = async (order_id) => {
    try {
      const response = await useApi.pawn_car.updateStatusToForfeiture(order_id);

      if (response.success) {
        fetchData();
      } else {
        console.error("Failed to update document status:", response.message);
        throw new Error(response.message);
      }
    } catch (error) {
      console.error("Error updating document status:", error);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography component={"div"} sx={{ fontSize: "32px" }}>
          รายการขายฝาก
        </Typography>
        <GradientButton
          onClick={() => {
            setIsOpenModal(true);
          }}
          sx={{
            px: 3,
            height: "48px",
          }}
          endIcon={<AddCircle fontSize="medium" />}
        >
          รายการขายฝาก
        </GradientButton>
      </Box>

      <Grid
        container
        spacing={2}
        sx={{
          mb: 2,
        }}
        textAlign={"right"}
      >
        <Grid item xs={12} sm={6} md={4}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontSize: "16px",
                  whiteSpace: "nowrap",
                }}
              >
                รหัสรายการ
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="รหัสรายการ"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "white",
                    height: "40px",
                  },
                }}
                value={filter.search}
                onChange={(e) => {
                  setFilter((prev) => ({
                    ...prev,
                    search: e.target.value,
                  }));
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontSize: "16px",
                  whiteSpace: "nowrap",
                }}
              >
                ยอดขายฝาก
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="รหัสรายการ"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "white",
                    height: "40px",
                  },
                }}
                value={filter.search}
                onChange={(e) => {
                  setFilter((prev) => ({
                    ...prev,
                    search: e.target.value,
                  }));
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={3} textAlign={"right"}>
              <Typography
                sx={{
                  fontSize: "16px",
                  whiteSpace: "nowrap",
                }}
              >
                ชื่อลูกค้า
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="ชื่อ-สกุล"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "white",
                    height: "40px",
                  },
                }}
                value={filter.searchName}
                onChange={(e) => {
                  setFilter((prev) => ({
                    ...prev,
                    searchName: e.target.value,
                  }));
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontSize: "16px",
                  whiteSpace: "nowrap",
                }}
              >
                เลขบัตรประชาชน
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="เลขบัตรประชาชน"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "white",
                    height: "40px",
                  },
                }}
                value={filter.searchIdcard}
                onChange={(e) => {
                  setFilter((prev) => ({
                    ...prev,
                    searchIdcard: e.target.value,
                  }));
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontSize: "16px",
                  whiteSpace: "nowrap",
                }}
              >
                วันที่ทำรายการ
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="วันที่ทำรายการ"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "white",
                    height: "40px",
                  },
                }}
                value={filter.searchDate}
                onChange={(e) => {
                  setFilter((prev) => ({
                    ...prev,
                    searchDate: e.target.value,
                  }));
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Box
            sx={{
              display: "flex",
              direction: "row",
              justifyContent: "flex-end",
            }}
          >
            <GradientButtonOutline
              onClick={() => {
                setFilter({
                  search: "",
                  searchName: "",
                  searchIdcard: "",
                  searchDate: "",
                  searchPrice: "",
                });
                if (pagination.page !== 1) {
                  setPagination((prev) => ({
                    ...prev,
                    page: 1,
                  }));
                } else {
                  fetchData();
                }
              }}
              sx={{
                px: 3,
                height: "40px",
              }}
            >
              ล้างค่า
            </GradientButtonOutline>
            <GradientButton
              onClick={() => fetchData()}
              sx={{
                px: 3,
                height: "40px",
                ml: 2,
              }}
            >
              ค้นหา
            </GradientButton>
          </Box>
        </Grid>
      </Grid>

      <TableData
        loading={loading}
        data={pawnCars}
        columns={[
          { key: "expand", label: "" },
          {
            key: "car_pictures",
            label: "รูปภาพ",
          },
          { key: "car_code", label: "รหัสรถ" },
          { key: "license_plate", label: "ทะเบียน" },
          { key: "customer_name", label: "ชื่อผู้ขายฝาก" },
          {
            key: "car_price",
            label: "ยอดขายฝาก",
            render: (row) =>
              formatCurrency2Digit(parseFloat(row.car_price || 0)),
          },

          {
            key: "created_date",
            label: "วันที่ขายฝาก",
            render: (row) => {
              return (
                <Typography sx={{ whiteSpace: "pre-line" }}>
                  {formatDateTime(row.created_date)}
                </Typography>
              );
            },
          },
          {
            key: "due_date",
            label: "วันที่สิ้นสุด",
            render: (row) => {
              return (
                <Typography sx={{ textAlign: "center" }}>
                  {formatDateMonthYear(row.due_date)}
                </Typography>
              );
            },
          },
          {
            key: "car_status",
            label: "สถานะ",
            render: (row) => {
              return <ChipCustomize status={row.car_status} />;
            },
          },
          {
            key: "action",
            label: "Actions",
            render: (row) => {
              return (
                <Actions
                  menuList={[
                    {
                      label: "ดูรายละเอียด",
                      icon: <Visibility />,
                      onClick: () => {
                        console.log("row", row);
                        setSelectedCar(row);
                        setIsDetailModalOpen(true);
                      },
                    },
                    {
                      label: "พิมพ์ใบขายฝาก",
                      icon: <Print />,
                      onClick: () => {
                        setSelectedCar(row);
                        setIsOpenModal(true);
                      },
                    },
                    {
                      label: "ต่อดอก",
                      icon: <Paid />,
                      onClick: () => {
                        setTypeActions("interest");
                        setSelectedCar(row);
                        setIsInterestModalOpen(true);
                      },
                    },
                    {
                      label: "ไถ่ถอน",
                      icon: <ChangeCircle />,
                      onClick: () => {
                        setTypeActions("redeem");
                        setSelectedCar(row);
                        setIsInterestModalOpen(true);
                      },
                    },
                    ...(row.car_status === "ค้างชำระ"
                      ? [
                          {
                            label: "ปรับต้นทุน",
                            icon: <ChangeCircle />,
                            onClick: () => {
                              setSelectedCar(row);
                            },
                          },
                          {
                            label: "หลุดจำนำ",
                            icon: <HourglassBottom />,
                            onClick: () => {
                              handleUpdateStsatusForFeiture(row.order_id);
                            },
                          },
                        ]
                      : []),
                    {
                      label: "ฟอร์มเอกสาร",
                      icon: <Description />,
                      onClick: () => {
                        console.log("Save clicked for row:", row);
                        navigate(`/car/pawn_cars/form/${row.id}`);
                      },
                    },
                  ]}
                />
              );
            },
          },
        ]}
      />
      <CustomPagination
        totalPage={pagination.totalPages}
        page={pagination.page - 1}
        onPageChange={(event, value) => {
          setPagination((prev) => ({ ...prev, page: value + 1 }));
        }}
        rowsPerPage={pagination.limit}
        onRowsPerPageChange={(event) => {
          setPagination((prev) => ({
            ...prev,
            limit: event.target.value,
            page: 1, // Reset to first page when changing rows per page
          }));
        }}
      />
      <ModalPawnCar
        open={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        fetchData={() => {
          fetchData(true);
        }}
      />

      <ModalDetailCar
        open={isDetailModalOpen}
        onClose={() => setIsDetailModalOpen(false)}
        rowID={selectedCar ? selectedCar.id : null}
        type="pawn_car"
        formlist={[
          {
            id: 1,
            document: "สัญญาจำนำ",
            document_type: "car_pawn_contact",
          },
          {
            id: 2,
            document: "หนังสือมอบอำนาจ",
            document_type: "car_power_of_attorney",
          },
          {
            id: 3,
            document: "แบบคำขอโอนและรับโอน",
            document_type: "car_transform",
          },
        ]}
      />

      <ModalInterest
        type={typeActions}
        isOpen={isInterestModalOpen}
        onClose={() => setIsInterestModalOpen(false)}
        rowID={selectedCar ? selectedCar.id : null}
        onSuccess={() => {
          setIsInterestModalOpen(false);
          fetchData();
        }}
      />
    </Box>
  );
};

export default PawnCars;
